// extracted by mini-css-extract-plugin
export default {"shadowed":"App_shadowed__BC3oN","h2FromProjectsPage":"App_h2FromProjectsPage__IwuIT"};